import PropTypes from 'prop-types';
import React, { Component } from 'react';
import range from 'lodash/range';
import { connect } from 'react-redux';
import { last, ifElse, pipe, divide, flip } from 'ramda';
import { t } from '../../../../modules/infra/i18n';

import config from '../../../../config';
import * as selector from '../../barbers/selector';
import withMinuteOptions, { minuteOptionShape } from '../../../common/hoc/withMinuteOptions';

const getHrsAndMinsFromMins = minutes => (
  minutes ? [Math.floor(minutes / 60), minutes % 60] : [0, 0]
);

const getMaxDuration = ifElse(
  last,
  pipe(last, flip(divide)(60)),
  () => config.maxCustomDuration / 60,
);

const hourOptionRenderFn = (item) => (
  <option key={item} value={item}>
    {t('appointment:form.duration_hours', { count: item })}
  </option>
);
const minuteOptionRenderFn = (item) => (
  <option key={item} value={item}>
    {t('appointment:form.duration_minutes', { count: item })}
  </option>
);

class SelectDuration extends Component {
  onDurationSelected = (e) => {
    const [hours, minutes] = getHrsAndMinsFromMins(this.props.selectedDuration);

    if (e.target.name === 'hours') {
      const newValue = (Number(e.target.value) * 60) + Number(minutes);
      return this.props.selectDuration(newValue);
    }

    const newValue = Number(e.target.value) + (Number(hours) * 60);
    return this.props.selectDuration(newValue);
  }

  render() {
    const { minuteOptions, durations } = this.props;
    const [hours, minutes] = getHrsAndMinsFromMins(this.props.selectedDuration);
    const disabled = this.props.timesFetching || !this.props.canModifyAppointments || !durations.length;
    const maxDuration = getMaxDuration(durations);

    return (
      <div className="layout__item u-mb--">
        <div className="c-label-new">{t('appointment:form.service_duration_label')}</div>
        <div className="layout__item u-2/5 u-pl0 u-mb--">
          <select
            name="hours"
            className="c-select"
            onChange={this.onDurationSelected}
            value={hours}
            disabled={disabled}
          >
            {range(0, maxDuration).map(hourOptionRenderFn)}
          </select>
        </div>
        <div className="layout__item u-2/5 u-pl0 u-ml- u-mb--">
          <select
            name="minutes"
            className="c-select"
            onChange={this.onDurationSelected}
            value={minutes}
            disabled={disabled}
          >
            {minuteOptions.map(minuteOptionRenderFn)}
          </select>
        </div>
      </div>
    );
  }
}

SelectDuration.propTypes = {
  selectDuration: PropTypes.func,
  selectedDuration: PropTypes.number,
  minuteOptions: minuteOptionShape.isRequired,
  timesFetching: PropTypes.bool,
  canModifyAppointments: PropTypes.bool.isRequired,
  durations: PropTypes.array.isRequired,
};

SelectDuration.defaultProps = {
  selectDuration: () => null,
  selectedDuration: 0,
  timesFetching: false,
};

const mapStateToProps = (state, props) => ({
  durations: selector.getBarberDurations(state, props.selectedBarber),
  timesFetching: state.barbers.availableTimes.loading,
});

export default connect(mapStateToProps)(withMinuteOptions(SelectDuration));
